export const CLASSIFICATION_TYPE_ROUTE_MAP: Record<string, string> = {
  'production-department': '/api/classification-production-department',
  'collection': '/api/classification-collection',
  'classification': '/api/classification-classification',
  'raw-material-type': '/api/classification-raw-material-type',
  'pa-type': '/api/classification-pa-type',
  'sa-type': '/api/classification-sa-type',
  'mp-pp-type': '/api/classification-mp-pp-type',
  'partner-type': '/api/classification-partner-type',
  // Legacy aliases
  'primary': '/api/classification-production-department',
  'secondary': '/api/classification-collection',
  'tertiary': '/api/classification-classification',
  'quaternary': '/api/classification-partner-type',
};
